import classNames from 'classnames';
import { IconV1 } from 'common/icon/iconV1.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { DisplayWhenHasModules } from 'components.layouts/five-up/five-up-utils.js';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { useSelector } from 'react-redux';
import { IRepoState } from 'redux-state/rootReducer.js';
import { IMenuItem } from 'types/menu.js';
import { isDevEnv } from 'utilities/consts/webpack-consts.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { trackNavigateEvent } from 'utilities/posthog-tracking';

export const secondaryItems: Array<IMenuItem> = [
  {
    name: 'News',
    link: 'https://about.metservice.com/news/',
    target: '_blank',
  },
  {
    name: 'About',
    link: 'https://about.metservice.com/our-company',
    target: '_blank',
  },
  {
    name: 'Products & Services',
    link: 'https://about.metservice.com/weather-for-business',
    target: '_blank',
  },
  {
    name: 'Contact',
    link: 'https://about.metservice.com/contact',
    target: '_blank',
  },
  {
    name: 'Careers',
    link: 'https://about.metservice.com/our-company/careers-and-job-opportunities',
    target: '_blank',
  },
  {
    name: 'Terms & Policies',
    link: 'https://about.metservice.com/terms-policies-and-notices',
    target: '_blank',
  },
];

export const Footer = () => {
  const data = useSelector((state: IRepoState) => state.LAYOUT.screen?.layout);
  const last = data?.last;
  const showPromo = Boolean(last?.modules?.length);

  return (
    <footer className="Footer">
      {showPromo && (
        <section className="Footer-section Footer-section--promo">
          <div className="Footer-promo-container">
            <div className="Container">
              <DisplayWhenHasModules section={last}>
                <ModulesLazyLoadWrapper section={getModulesMetaData('footer-last', last?.modules)}>
                  <ModuleArrLoad modules={last?.modules} modulePath={ModulePath.FOOTER_PROMO} />
                </ModulesLazyLoadWrapper>
              </DisplayWhenHasModules>
            </div>
          </div>
        </section>
      )}

      <section className="Footer-section Footer-section--global">
        <div className="Container">
          <div className="Grid Grid--withGutter">
            <div className="Grid-cell u-md-width1of2 u-lg-width3of12">
              <div className="Footer-section-logo u-sm-m-auto u-sm-mT-sm">
                <IconV1 icon="main-logo" />
              </div>
            </div>

            <div className="Grid-cell u-sm-hidden u-md-hidden u-lg-inlineBlock u-lg-width6of12">
              <ul className="Footer-section-links">
                {secondaryItems.map(({ link, target, name }, index) => (
                  <li key={index}>
                    <LinkFactoryReactRouter href={link} target={target} onClick={() => trackNavigateEvent("site_footer", name + "_link")}>
                      {name}
                    </LinkFactoryReactRouter>
                  </li>
                ))}
              </ul>
            </div>

            <div className="Grid-cell u-md-width1of2 u-lg-width3of12">
              <ul className="Footer-section-social u-sm-m-auto">
                <li className="Footer-section-social-item ">
                  <a
                    href="https://www.facebook.com/MetService/"
                    className="svg--fill-inherit svg--fill-hover"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <IconV1 icon="facebook" iconClass="svg--1em" />
                  </a>
                </li>
                <li className="Footer-section-social-item">
                  <a
                    href="https://www.instagram.com/metservicenz/"
                    className="svg--fill-inherit svg--fill-hover"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <IconV1 icon="instagram" iconClass="svg--1em" />
                  </a>
                </li>
                <li className="Footer-section-social-item">
                  <a
                    href="https://twitter.com/metservice?lang=en"
                    className="svg--fill-inherit svg--fill-hover"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <IconV1 icon="twitter" iconClass="svg--1em" />
                  </a>
                </li>
                <li className="Footer-section-social-item">
                  <a
                    href="https://www.linkedin.com/company/59947/"
                    className="svg--fill-inherit svg--fill-hover"
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <IconV1 icon="linkedin" iconClass="svg--1em" />
                  </a>
                </li>
              </ul>
            </div>

            <div className="Grid-cell u-width1of1">
              <p className="Footer-section-legal">
                This information is provided for your own personal non-commercial use in accordance with the MetService
                website{' '}
                <LinkFactoryReactRouter href="https://about.metservice.com/web-terms-of-use" target="_blank">
                  terms of use
                </LinkFactoryReactRouter>
                .
              </p>
              <p className="Footer-section-legal">
                Copyright Meteorological Service of New Zealand Ltd. 2008-{new Date().getFullYear()}
              </p>
              <p className={classNames('Footer-section-legal', { 'u-hidden': !isDevEnv(true) })}>
                Version: {__VERSION__}
              </p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};
